<header #headerEl class="site-header" [class.scrolled]="isScrolled">
  <div class="site-header-inner">
    <div class="header-main">
      <a class="brand" routerLink="/" (click)="closeMobile()">
        <span class="brand-mark">M</span>
        <span class="brand-copy">
          <strong>MKZS.tech</strong>
          <small>.NET & Azure engineering</small>
        </span>
      </a>
      <button
        class="mobile-toggle"
        type="button"
        (click)="toggleMobile()"
        [attr.aria-expanded]="mobileOpen"
        aria-controls="primary-nav"
        aria-label="Toggle navigation menu"
      >
        <span class="hamburger" [class.open]="mobileOpen"></span>
      </button>
      <nav
        id="primary-nav"
        aria-label="Primary"
        class="site-nav"
        [class.mobile-open]="mobileOpen"
      >
        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMobile()">Home</a>
        <a routerLink="/about" routerLinkActive="active" (click)="closeMobile()">About</a>
        <a routerLink="/services" routerLinkActive="active" (click)="closeMobile()">Services</a>
        <a routerLink="/portfolio" routerLinkActive="active" (click)="closeMobile()">Case Studies</a>
        <a routerLink="/contact" routerLinkActive="active" (click)="closeMobile()">Contact</a>
        @if (authEnabled && authService.isAuthenticated()) {
          <a routerLink="/account" routerLinkActive="active" (click)="closeMobile()">Account</a>
        }
        @if (authEnabled && authService.isPortalAdmin()) {
          <a routerLink="/admin" routerLinkActive="active" (click)="closeMobile()">Admin</a>
        }
      </nav>
    </div>

    <div class="auth-panel">
      @if (authEnabled && authService.isAuthenticated()) {
        <div class="auth-copy">
          <span class="auth-label">Signed in</span>
          <strong>{{ authService.displayName() }}</strong>
        </div>
        <button type="button" class="btn-secondary" (click)="signOutRequested.emit()">Sign out</button>
      } @else if (authEnabled) {
        <button type="button" class="btn-secondary" (click)="signInRequested.emit()">Sign in</button>
      }
      <a class="header-cta" routerLink="/contact" (click)="closeMobile()">Book a Discovery Call</a>
    </div>
  </div>
</header>
